<template>

<div>

    <h1>Create new resort</h1>

    <div class="box">

      <Errors/>

      <form class="form" v-on:submit.prevent="createResort">

        <ResortFields></ResortFields>

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled>Creating...</button>
          </div>
          <div v-else>
            <button type="submit" class="button">Create resort</button>
          </div>
        </div>

      </form>
    </div>

</div>

</template>

<script>
import ResortFields from '@/components/ResortFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'ResortCreate',
  computed: mapGetters(['getLoadStatus']),
  data () {
    return {
      resort: {},
      errors: null
    }
  },
  components: {
    ResortFields,
    Errors
  },
  methods: {
    createResort () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'resorts', {
        method: 'POST',
        body: JSON.stringify(this.resort),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success) {
          this.$router.push({ name: 'resort-edit', params: { id: response.data.id }})
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}
</script>
